import {SET_COORDS} from "./types";

const initState = {
    lat: '',
    lng: '',

}

export const myCoordsReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_COORDS:
            return {
                ...state,
                lat: action.payload.lat,
                lng: action.payload.lng,
            }

        default:
            return state
    }
}